
import React from "react";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSelector } from "react-redux";

export default function DropDownForDurations(props) {

  const { selectedDuration } = useSelector((state) => state.createOrderSlice)



  const { label, options, onChange, optionsExtraText, error } = props;

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          onChange={onChange}
          value={selectedDuration}
        >
          {options.map((item) => {
            return (
              <MenuItem value={item}>{item} ({optionsExtraText})</MenuItem>
            )

          })}

        </Select>
        {error ? !selectedDuration && <p className='form-error-message'>This field is required</p> : null}

      </FormControl>
    </Box>
  );


}


